/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type LiveShareFolder_folder = {
    readonly slug: string;
    readonly name: string;
    readonly attachments: ReadonlyArray<{
        readonly name: string;
        readonly isImage: boolean;
        readonly " $fragmentRefs": FragmentRefs<"LiveShareEntityAttachment_attachment">;
    }>;
    readonly " $refType": "LiveShareFolder_folder";
};
export type LiveShareFolder_folder$data = LiveShareFolder_folder;
export type LiveShareFolder_folder$key = {
    readonly " $data"?: LiveShareFolder_folder$data;
    readonly " $fragmentRefs": FragmentRefs<"LiveShareFolder_folder">;
};



const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "LiveShareFolder_folder",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "LiveShareEntityAttachment",
      "kind": "LinkedField",
      "name": "attachments",
      "plural": true,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "isImage",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "LiveShareEntityAttachment_attachment"
        }
      ],
      "storageKey": null
    }
  ],
  "type": "LiveShareFolder",
  "abstractKey": null
};
})();
(node as any).hash = 'd59f27a54975f39962da22cd4460ed1a';
export default node;
